module.exports = __webpack_public_path__ + "img/con_6.245184cd.svg";